import ListListings from "../components/mainpage/ListListings"
import { ListingContextProvider } from "../context/ListingsContext"
import { useState } from "react"
import {
    collection,
    query,
    where,
    getDocs,
    and,
    orderBy,
} from "firebase/firestore"
import { db } from "../firebase"
import { useEffect, useContext } from "react"
import Button from "react-bootstrap/esm/Button";
import { AuthContext } from "../context/AuthContext"
import ModalWrapper from "../components/ModalWrapper"
import InputListing from "../components/InputListing"

const MyListings = () => {
    const [listings, setListings] = useState(null)
    const [inputListingOpen, setInputListingOpen] = useState(false)

    const { currentUser } = useContext(AuthContext)

    const getListings = async() => {
        try {
            const q = query(collection(db, "listings"), and(where("user.userId", "==", currentUser.uid), where("active", "==", true)), orderBy("createdAt", "desc"))
            const querySnapshot = await getDocs(q)
            const queryRes = []
            querySnapshot.forEach((doc) => {
                const docData = doc.data()
                docData.listing_id = doc.id
                queryRes.push(docData)
            })
            setListings(queryRes)
        } catch(err) {
            console.error(err.message)
        }
    }

    useEffect(() => {
        getListings()
    }, [currentUser])

    return (
        <ListingContextProvider>
            <div className='my-listings-container page-container'>
                <div className='listings-div'>
                    <ModalWrapper
                        show={inputListingOpen}
                        onHide={() => setInputListingOpen(false)}
                        heading="Create Listing"
                    >
                        <InputListing/>
                    </ModalWrapper>
                    <div className="page-header">
                        <span className="header-text">
                            My Listings
                        </span>
                        <Button className="input-button" variant="primary" onClick={() => setInputListingOpen(true)}>
                            New Listing
                        </Button>
                    </div>
                    {
                        currentUser ? <ListListings listings={listings} setListings={setListings} className={"listings-grid-full-page"}/> : <div>Loading</div>
                    }
                </div>
            </div>
        </ListingContextProvider>
    )
}

export default MyListings